import _asyncToGenerator from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _wrapAsyncGenerator from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
import _awaitAsyncGenerator from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _asyncIterator from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncIterator";
import _asyncGeneratorDelegate from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncGeneratorDelegate";

/**
 * Attaches a cleanup handler to a AsyncIterable.
 *
 * @param source The source that should have a return handler attached
 * @param onReturn The return handler that should be attached
 * @returns
 */
function withHandlers(source, onReturn, onThrow) {
  var stream = function () {
    var _withReturnSource = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(source), _awaitAsyncGenerator), "t0", 1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function withReturnSource() {
      return _withReturnSource.apply(this, arguments);
    }

    return withReturnSource;
  }()();

  var originalReturn = stream.return.bind(stream);

  if (onReturn) {
    stream.return = function () {
      onReturn();
      return originalReturn.apply(void 0, arguments);
    };
  }

  if (onThrow) {
    var originalThrow = stream.throw.bind(stream);

    stream.throw = function (err) {
      onThrow(err);
      return originalThrow(err);
    };
  }

  return stream;
}

function createDeferred() {
  var d = {};
  d.promise = new Promise(function (resolve, reject) {
    d.resolve = resolve;
    d.reject = reject;
  });
  return d;
}
/**
 * makePushPullAsyncIterableIterator
 *
 * The iterable will publish values until return or throw is called.
 * Afterwards it is in the completed state and cannot be used for publishing any further values.
 * It will handle back-pressure and keep pushed values until they are consumed by a source.
 */


function makePushPullAsyncIterableIterator() {
  var state = {
    type: "running"
    /* running */

  };
  var next = createDeferred();
  var values = [];

  function pushValue(value) {
    if (state.type !== "running"
    /* running */
    ) {
      return;
    }

    values.push(value);
    next.resolve();
    next = createDeferred();
  }

  var source = function () {
    var _PushPullAsyncIterableIterator = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!true) {
                _context2.next = 14;
                break;
              }

              if (!(values.length > 0)) {
                _context2.next = 6;
                break;
              }

              _context2.next = 4;
              return values.shift();

            case 4:
              _context2.next = 12;
              break;

            case 6:
              if (!(state.type === "error"
              /* error */
              )) {
                _context2.next = 8;
                break;
              }

              throw state.error;

            case 8:
              if (!(state.type === "finished"
              /* finished */
              )) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("return");

            case 10:
              _context2.next = 12;
              return _awaitAsyncGenerator(next.promise);

            case 12:
              _context2.next = 0;
              break;

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function PushPullAsyncIterableIterator() {
      return _PushPullAsyncIterableIterator.apply(this, arguments);
    }

    return PushPullAsyncIterableIterator;
  }()();

  var stream = withHandlers(source, function () {
    if (state.type !== "running"
    /* running */
    ) {
      return;
    }

    state = {
      type: "finished"
      /* finished */

    };
    next.resolve();
  }, function (error) {
    if (state.type !== "running"
    /* running */
    ) {
      return;
    }

    state = {
      type: "error"
      /* error */
      ,
      error: error
    };
    next.resolve();
  });
  return {
    pushValue: pushValue,
    asyncIterableIterator: stream
  };
}

var makeAsyncIterableIteratorFromSink = function makeAsyncIterableIteratorFromSink(make) {
  var _makePushPullAsyncIte = makePushPullAsyncIterableIterator(),
      pushValue = _makePushPullAsyncIte.pushValue,
      asyncIterableIterator = _makePushPullAsyncIte.asyncIterableIterator;

  var dispose = make({
    next: function next(value) {
      pushValue(value);
    },
    complete: function complete() {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      asyncIterableIterator.return();
    },
    error: function error(err) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      asyncIterableIterator.throw(err);
    }
  }); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

  var originalReturn = asyncIterableIterator.return;
  var returnValue = undefined;

  asyncIterableIterator.return = function () {
    if (returnValue === undefined) {
      dispose();
      returnValue = originalReturn();
    }

    return returnValue;
  };

  return asyncIterableIterator;
};

function applyAsyncIterableIteratorToSink(asyncIterableIterator, sink) {
  var run = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, value;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context3.prev = 3;
              _iterator = _asyncIterator(asyncIterableIterator);

            case 5:
              _context3.next = 7;
              return _iterator.next();

            case 7:
              if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
                _context3.next = 13;
                break;
              }

              value = _step.value;
              sink.next(value);

            case 10:
              _iteratorAbruptCompletion = false;
              _context3.next = 5;
              break;

            case 13:
              _context3.next = 19;
              break;

            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context3.t0;

            case 19:
              _context3.prev = 19;
              _context3.prev = 20;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context3.next = 24;
                break;
              }

              _context3.next = 24;
              return _iterator.return();

            case 24:
              _context3.prev = 24;

              if (!_didIteratorError) {
                _context3.next = 27;
                break;
              }

              throw _iteratorError;

            case 27:
              return _context3.finish(24);

            case 28:
              return _context3.finish(19);

            case 29:
              sink.complete();
              _context3.next = 35;
              break;

            case 32:
              _context3.prev = 32;
              _context3.t1 = _context3["catch"](0);
              sink.error(_context3.t1);

            case 35:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 32], [3, 15, 19, 29], [20,, 24, 28]]);
    }));

    return function run() {
      return _ref.apply(this, arguments);
    };
  }();

  run();
  return function () {
    var _a;

    (_a = asyncIterableIterator.return) === null || _a === void 0 ? void 0 : _a.call(asyncIterableIterator);
  };
}

function isAsyncIterable(input) {
  return typeof input === "object" && input !== null && (input[Symbol.toStringTag] === "AsyncGenerator" || Symbol.asyncIterator && Symbol.asyncIterator in input);
}
/**
 * Attaches a cleanup handler from and AsyncIterable to an AsyncIterable.
 *
 * @param source
 * @param target
 */


function withHandlersFrom(
/** The source that should be returned with attached handlers. */
source,
/**The target on which the return and throw methods should be called. */
target) {
  return withHandlers(source, function () {
    var _a;

    return (_a = target.return) === null || _a === void 0 ? void 0 : _a.call(target);
  }, function (err) {
    var _a;

    return (_a = target.throw) === null || _a === void 0 ? void 0 : _a.call(target, err);
  });
}

function filter(filter) {
  return /*#__PURE__*/function () {
    var _filterGenerator = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(asyncIterable) {
      var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, value;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _iteratorAbruptCompletion2 = false;
              _didIteratorError2 = false;
              _context4.prev = 2;
              _iterator2 = _asyncIterator(asyncIterable);

            case 4:
              _context4.next = 6;
              return _awaitAsyncGenerator(_iterator2.next());

            case 6:
              if (!(_iteratorAbruptCompletion2 = !(_step2 = _context4.sent).done)) {
                _context4.next = 14;
                break;
              }

              value = _step2.value;

              if (!filter(value)) {
                _context4.next = 11;
                break;
              }

              _context4.next = 11;
              return value;

            case 11:
              _iteratorAbruptCompletion2 = false;
              _context4.next = 4;
              break;

            case 14:
              _context4.next = 20;
              break;

            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](2);
              _didIteratorError2 = true;
              _iteratorError2 = _context4.t0;

            case 20:
              _context4.prev = 20;
              _context4.prev = 21;

              if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                _context4.next = 25;
                break;
              }

              _context4.next = 25;
              return _awaitAsyncGenerator(_iterator2.return());

            case 25:
              _context4.prev = 25;

              if (!_didIteratorError2) {
                _context4.next = 28;
                break;
              }

              throw _iteratorError2;

            case 28:
              return _context4.finish(25);

            case 29:
              return _context4.finish(20);

            case 30:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 16, 20, 30], [21,, 25, 29]]);
    }));

    function filterGenerator(_x) {
      return _filterGenerator.apply(this, arguments);
    }

    return filterGenerator;
  }();
}
/**
 * Map the events published by an AsyncIterable.
 */


var map = function map(_map) {
  return /*#__PURE__*/function () {
    var _mapGenerator = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(asyncIterable) {
      var _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, value;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _iteratorAbruptCompletion3 = false;
              _didIteratorError3 = false;
              _context5.prev = 2;
              _iterator3 = _asyncIterator(asyncIterable);

            case 4:
              _context5.next = 6;
              return _awaitAsyncGenerator(_iterator3.next());

            case 6:
              if (!(_iteratorAbruptCompletion3 = !(_step3 = _context5.sent).done)) {
                _context5.next = 13;
                break;
              }

              value = _step3.value;
              _context5.next = 10;
              return _map(value);

            case 10:
              _iteratorAbruptCompletion3 = false;
              _context5.next = 4;
              break;

            case 13:
              _context5.next = 19;
              break;

            case 15:
              _context5.prev = 15;
              _context5.t0 = _context5["catch"](2);
              _didIteratorError3 = true;
              _iteratorError3 = _context5.t0;

            case 19:
              _context5.prev = 19;
              _context5.prev = 20;

              if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
                _context5.next = 24;
                break;
              }

              _context5.next = 24;
              return _awaitAsyncGenerator(_iterator3.return());

            case 24:
              _context5.prev = 24;

              if (!_didIteratorError3) {
                _context5.next = 27;
                break;
              }

              throw _iteratorError3;

            case 27:
              return _context5.finish(24);

            case 28:
              return _context5.finish(19);

            case 29:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 15, 19, 29], [20,, 24, 28]]);
    }));

    function mapGenerator(_x2) {
      return _mapGenerator.apply(this, arguments);
    }

    return mapGenerator;
  }();
};

export { applyAsyncIterableIteratorToSink, filter, isAsyncIterable, makeAsyncIterableIteratorFromSink, makePushPullAsyncIterableIterator, map, withHandlers, withHandlersFrom };